export const featureType = [
  {
    label: '식단 입력',
    type: 'MEAL',
  },
  {
    label: 'test',
    type: 'test',
  },
]

export const programOption = [
  {
    label: '2주 (14일)',
    type: '14',
  },
  {
    label: '4주 (28일)',
    type: '28',
  },
]
